import { Route, Routes, Outlet } from "react-router-dom";
import YoutubePage from "./YoutubeAnalytics";
import YoutubeComments from "./YoutubeComments";
import Instagram from "./Instagram/Instagram";
import Post from "./Instagram/Post";


const SocialMediaRoutes = () => {
  return (
    <div
      id="kt_app_content_container"
      className="app-container mx-5"
      style={{ overflow: "hidden" }}
    >
      <div
        className="card card-flush"
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 120px)',
          overflow: 'hidden',
        }}
      >
        <div
          className="card-body d-flex flex-column"
          style={{ minHeight: 0, flex: 1, overflow: 'hidden' }}
        >
          <Routes>
            <Route element={<Outlet />}>
              <Route path="youtube" element={<YoutubePage />} />
              <Route
                path="youtube/video/:videoId"
                element={<YoutubeComments />}
              />
              <Route path ='instagram' element={<Instagram />} />
              <Route path ='post' element={<Post />} />
            </Route>
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaRoutes;
